<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view :client-height='clientHeight' />
    </transition>
  </div>
</template>

<script>
import config from './config/config';
export default {
  name: "App",
  data() {
    return {
      clientHeight: 0,
      transitionName: "",
      timer: false,
      audioTimer: null,
      continueAudio: true,
    };
  },
  created() {
    this.clientHeight = document.documentElement.clientHeight;
    const that = this;
    window.onresize = () => {
      return (() => {
        window.clientHeight = document.documentElement.clientHeight;
        that.clientHeight = window.clientHeight;
      })();
    }
  },
  methods: {
    /** 
     * @method 音频播报封装函数
     * @param { txt: String } 语音播报内容
    */
    audioSpeak(txt) {
      const url = `${config.ttsUrl}+${encodeURI(txt)}`;
      new Audio(url).play();
    },
    socketMonitor(evt) {
      const receiveData = JSON.parse(evt.data);
      if (receiveData.type === 'reserve_list') {
        if (receiveData.has_new_video_wait) {
          if (this.$route.name !== 'liveRoom' && this.$route.name !== 'makeRecipe' && this.continueAudio) {
            clearTimeout(this.audioTimer);
            this.$notify({
              title: '患者信息更新通知',
              message: `您有新的患者，请及时查看处理。`,
              type: 'success',
              duration: 10000,
              showClose: true,
            });
            this.continueAudio = false;
            this.audioSpeak('您有新的患者，请及时查看处理。');
            this.audioTimer = setTimeout(() => {
              this.audioSpeak('您有新的患者，请及时查看处理。');
            }, 5000);
            setTimeout(() => {
              this.continueAudio = true;
            }, 10000);
          }
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.meta.requireAuth) {
        setTimeout(() => {  
          if (!this.gbSocket.socket) {
            const proto = '__proto__';
            const token = this.$session.fetch('doctorToken');
            this[proto][proto].gbSocket.init(token); // 将 socket 挂载到 vue 原型上
          }
          this.gbSocket.socket.addEventListener('message', this.socketMonitor);
        }, 500);
      }
      if (to.name === 'Login' && from.name) {
        this.gbSocket.socket.removeEventListener('message', this.socketMonitor);
        clearTimeout(this.audioTimer);
      }
      if (to.meta.index > from.meta.index) {
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
    clientHeight(val) {
      if (!this.timer) {
        this.clientHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(() => {
          that.timer = false;
        }, 500);
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Microsoft Yahei";
}
.transitionRouter-enter-active,
.transitionRouter-leave-active {
  transition: all 0.4s;
}

.transitionRouter-enter,
.transitionRouter-leave {
  transform: translate3d(100%, 0, 0);
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.3s;
  position: absolute;
  width: 100%;
  left: 0;
}
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
}
.img-shadow{
  box-shadow:2px 2px 3px 0 #dedede;
}
.back-btn:hover {
  background-color: #C1C1C1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue